import User from './User';
import UserProvider from './UserContext';

let Index = () => {
    return (
        <UserProvider>
            <User />
        </UserProvider>
    )
}

export default Index;